import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

import { DefaultMira, Favorite, FavoriteStatus, ListFavoritesResponse } from '@irohalab/mira-sdk-angular';
import { Subscription } from 'rxjs';
import { UIPagination, UIResponsiveImageWrapper } from '@irohalab/deneb-ui';
import { NavbarComponent } from '../navbar/navbar.component';
import { UserActionComponent } from '../user-action/user-action.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { FormsModule } from '@angular/forms';

const PAGE_SIZE = 24;

@Component({
    selector: 'app-favorite-list',
    imports: [
    NavbarComponent,
    UserActionComponent,
    RouterLink,
    UIResponsiveImageWrapper,
    UIPagination,
    SidebarComponent,
    FormsModule
],
    templateUrl: './favorite-list.component.html',
    styleUrl: './favorite-list.component.less'
})
export class FavoriteListComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  favorites: Favorite[] = [];
  total = 0;
  currentPage = 1;
  pageSize = PAGE_SIZE;

  selectedStatus: string = FavoriteStatus.Watching;
  orderBy: string = '';
  sort: string = 'desc';

  statusOptions = [
    { value: FavoriteStatus.Watching, label: '在看' },
    { value: FavoriteStatus.Planned, label: '想看' },
    { value: FavoriteStatus.Watched, label: '看过' },
    { value: FavoriteStatus.OnHold, label: '搁置' },
    { value: FavoriteStatus.Dropped, label: '抛弃' },
  ];

  sortFieldOptions = [
    { value: '', label: '默认' },
    { value: 'rating', label: '评分' },
  ];

  sortDirectionOptions = [
    { value: 'desc', label: '降序' },
    { value: 'asc', label: '升序' },
  ];

  constructor(private miraApiService: DefaultMira) {}

  ngOnInit(): void {
    this.loadFavorites();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.loadFavorites();
  }

  onStatusChange(): void {
    this.currentPage = 1;
    this.loadFavorites();
  }

  onSortChange(): void {
    this.currentPage = 1;
    this.loadFavorites();
  }

  private loadFavorites(): void {
    const offset = (this.currentPage - 1) * this.pageSize;
    this.subscription.add(
      this.miraApiService.listFavorites(
        this.selectedStatus,
        offset,
        this.pageSize,
        this.orderBy || undefined,
        this.sort || undefined,
      ).subscribe((resp: ListFavoritesResponse) => {
        this.favorites = resp.data;
        this.total = resp.total;
      })
    );
  }
}
